import { SportSliderDict } from '@draftkings/sportsbook-common-contracts';

export const dict: SportSliderDict = {
    arrowLeft: 'Arrow pointing left icon',
    arrowRight: 'Arrow pointing right icon',
    refresh: 'Refresh',
    logo: 'logo'
};
